import { Button } from 'antd';
import styled from 'styled-components';
import { spaceTop } from '@xbcb/ui-styles';

export const StyledButton = styled(Button)`
  ${spaceTop}
`;
